/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  addDecoderSizePrefix,
  addEncoderSizePrefix,
  combineCodec,
  getArrayDecoder,
  getArrayEncoder,
  getStructDecoder,
  getStructEncoder,
  getU32Decoder,
  getU32Encoder,
  getU64Decoder,
  getU64Encoder,
  getUtf8Decoder,
  getUtf8Encoder,
  type Codec,
  type Decoder,
  type Encoder,
} from "@solana/kit";
import {
  getTrendDirectionDecoder,
  getTrendDirectionEncoder,
  getViolationSeverityDecoder,
  getViolationSeverityEncoder,
  type TrendDirection,
  type TrendDirectionArgs,
  type ViolationSeverity,
  type ViolationSeverityArgs,
} from ".";

/** Risk indicator */
export type RiskIndicator = {
  /** Indicator name */
  name: string;
  /** Current value */
  currentValue: bigint;
  /** Threshold value */
  thresholdValue: bigint;
  /** Trend direction */
  trend: TrendDirection;
  /** Severity if threshold exceeded */
  severity: ViolationSeverity;
  /** Recommended actions */
  recommendedActions: Array<string>;
};

export type RiskIndicatorArgs = {
  /** Indicator name */
  name: string;
  /** Current value */
  currentValue: number | bigint;
  /** Threshold value */
  thresholdValue: number | bigint;
  /** Trend direction */
  trend: TrendDirectionArgs;
  /** Severity if threshold exceeded */
  severity: ViolationSeverityArgs;
  /** Recommended actions */
  recommendedActions: Array<string>;
};

export function getRiskIndicatorEncoder(): Encoder<RiskIndicatorArgs> {
  return getStructEncoder([
    ["name", addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder())],
    ["currentValue", getU64Encoder()],
    ["thresholdValue", getU64Encoder()],
    ["trend", getTrendDirectionEncoder()],
    ["severity", getViolationSeverityEncoder()],
    [
      "recommendedActions",
      getArrayEncoder(addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder())),
    ],
  ]);
}

export function getRiskIndicatorDecoder(): Decoder<RiskIndicator> {
  return getStructDecoder([
    ["name", addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder())],
    ["currentValue", getU64Decoder()],
    ["thresholdValue", getU64Decoder()],
    ["trend", getTrendDirectionDecoder()],
    ["severity", getViolationSeverityDecoder()],
    [
      "recommendedActions",
      getArrayDecoder(addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder())),
    ],
  ]);
}

export function getRiskIndicatorCodec(): Codec<
  RiskIndicatorArgs,
  RiskIndicator
> {
  return combineCodec(getRiskIndicatorEncoder(), getRiskIndicatorDecoder());
}
